import { executeVSCodeCommand } from "utils/vscode";

import type { Command } from "../../types";

export const useOpenVMSpecs = (): Command => {
  return {
    id: "codesandbox.vmspecs.open",
    name: "Virtual machine",
    section: "CodeSandbox",
    perform: () => {
      executeVSCodeCommand("codesandbox.openCsbTab", {
        type: "VIRTUAL_MACHINE",
      });
    },
  };
};
